// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions
// tslint:disable:no-identical-functions

import { IDynamicBindableValue } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { State as AccountState } from '@epicuro-next/state/accounts-state';
import { UnwrapMaybe } from '@epicuro-next/utilities';

export type BrandOrgType = Exclude<
  UnwrapMaybe<
    Exclude<
      Exclude<
        Exclude<AccountState['activeAccount'], null>['brandOrganisations'],
        undefined
      >,
      null
    >[0]
  >,
  null
>;

export function getBrandOrganisation(): IDynamicBindableValue {
  return {
    provider: 'GlobalStoreProviderService',
    property: {
      path: 'accounts.activeAccount.brandOrganisations',
    },
    filter: function (brandOrganisations: [] | null | undefined): boolean {
      const hasBrandOrganisations =
        !!brandOrganisations && brandOrganisations.length > 0;
      return hasBrandOrganisations;
    }.toString(),
    transform: function (brandOrganisations: BrandOrgType[]): BrandOrgType {
      return brandOrganisations[0];
    }.toString(),
  };
}

export function getBrandId(): IDynamicBindableValue {
  return {
    provider: 'GlobalStoreProviderService',
    property: {
      path: 'accounts.activeAccount.brandOrganisations',
    },
    filter: function (brandOrganisations: [] | null | undefined): boolean {
      const hasBrandOrganisations =
        !!brandOrganisations && brandOrganisations.length > 0;
      return hasBrandOrganisations;
    }.toString(),
    transform: function (brandOrganisations: BrandOrgType[]): string {
      return brandOrganisations[0].brandId;
    }.toString(),
  };
}
